import React, {
    ReactElement,
} from "react";
import { Dropdown } from "react-bootstrap";
import { BiCheckSquare, BiSquareRounded } from "react-icons/bi";
import { GrFormFilter } from "react-icons/gr";

export interface FilterPropGroupItem {
    id: string;
    name: string;
}
export interface FilterPropGroupDivider {
    isDivider: true;
}

export type FilterPropGroup = FilterPropGroupItem | FilterPropGroupDivider;
interface FilterProps<TIsMulti = true> {
    categories: FilterPropGroup[];
    selectedCategories: TIsMulti extends true ? Set<string> : string;
    onSelected: (ids: (TIsMulti extends true ? Set<string> : string)) => void;
    search?: string;
    onSetSearch?: (value: string) => void;
    isMulti?: TIsMulti;
    className?: string;
    toggleText?: string | ReactElement;
    toggleClassName?: string;
    canSelect?: boolean;
}

function isDivider(item: FilterPropGroup): item is FilterPropGroupDivider {
    return Object.hasOwn(item, "isDivider");
}
export function Filters<TIsMulti extends boolean = true>({
    categories, selectedCategories, onSelected, search, onSetSearch, isMulti, className, toggleText, toggleClassName,
    canSelect,
}: FilterProps<TIsMulti>): ReactElement {
    return (
        <div className={`d-flex align-items-center ${className}`}>
            {categories.isNotEmpty && (
                <Dropdown autoClose="outside">
                    <Dropdown.Toggle
                        variant=""
                        className={toggleText ? toggleClassName : "menu-small p-1"}
                    >
                        {toggleText ? (
                            <>
                                {toggleText}
                                {" "}
                                {selectedCategories instanceof Set
                                && selectedCategories?.size > 0
                                && `${selectedCategories.size} selected`}
                            </>
                        ) : <GrFormFilter />}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {categories.map(item => (
                            isDivider(item)
                                ? <Dropdown.Divider />
                                : (
                                    <Dropdown.Item
                                        key={item.id}
                                        eventKey={item.id}
                                        onClick={() => {
                                            if (isMulti) {
                                                const seleted = selectedCategories as Set<string>;
                                                if (seleted.has(item.id)) {
                                                    seleted.delete(item.id);
                                                } else {
                                                    seleted.add(item.id);
                                                }
                                                const handler = onSelected as ((val: Set<string>) => void);
                                                handler(new Set(Array.from(seleted)
                                                    .union(categories.mapFilter(row => (!isDivider(row) ? row.id : undefined)))));
                                            } else {
                                                (onSelected as ((val: string) => void))(item.id);
                                            }
                                        }}
                                    >
                                        {canSelect && (
                                            ((selectedCategories instanceof Set)
                                        && selectedCategories.has(item.id)) || selectedCategories === item.id
                                                ? <BiCheckSquare />
                                                : <BiSquareRounded />)}

                                        {" "}
                                        {item.name}
                                    </Dropdown.Item>
                                )
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            )}
            {onSetSearch && (
                <input
                    className="no-border ms-2"
                    type="search"
                    placeholder="Search..."
                    value={search}
                    onChange={evt => onSetSearch(evt.target.value)}
                />
            )}

        </div>
    );
}

Filters.defaultProps = {
    isMulti: true,
    onSetSearch: undefined,
    search: "",
    className: "mb-1",
    toggleText: undefined,
    toggleClassName: "",
    canSelect: true,
};
